// extracted by mini-css-extract-plugin
export default {"btn":"Speech_btn__-Yioo"};